import { useRenderGuard } from 'apprise-frontend-core/utils/renderguard'
import { SettingsClientCache, SettingsModuleProvider } from 'apprise-frontend-streams/settings/context'
import { PropsWithChildren } from 'react'
import { useSettingStore } from './api'
import { ChangeObserver } from './events'







export type SettingsProps = PropsWithChildren


export const Settings = (props: SettingsProps) => {

    const { children } = props

    return <SettingsModuleProvider>
        <SettingsClientCache>
            <CacheLoader>
                <ChangeObserver />
                {children}
            </CacheLoader>
        </SettingsClientCache>
    </SettingsModuleProvider>
}

const CacheLoader = (props: SettingsProps) => {

    const { children } = props

    const store = useSettingStore()

    const { content } = useRenderGuard({

        render: children,
        orRun: store.fetch
    })


    return content
}

